import theme from '@css/theme';
import styled from 'styled-components';
import { Flex } from '@ui-library/misc';
import { H1, Body } from '@ui-library/typography';

export const Container = styled(Flex)`
  background-color: ${theme.color.background1};
  min-height: 100vh;
  box-shadow: 0px 4px 8px rgba(33, 37, 44, 0.04), 0px 0px 2px rgba(33, 37, 44, 0.06),
    0px 0px 1px rgba(33, 37, 44, 0.04);
`;

export const Content = styled.div`
  background-color: white;
  width: 500px;
  height: 300px;
  padding: 48px;
`;

export const Link = styled.span`
  color: ${theme.color.rsPrimary};
`;

export const Title = styled(H1)`
  font-weight: 800;
  margin-top: 16px;
`;

export const Text = styled(Body)`
  color: ${theme.color.neutral3};
`;

export const Info = styled(Text)`
  margin: 16px 0;
  word-wrap: break-word;
`;
